import { DomainEvent } from "./DomainEvent";

export class CommentCreatedEvent extends DomainEvent {
    static eventType = 'comment_create';
    
    #userId;
    #productId;
    #productOwnerId;
    #isSeller;
    #timeSinceLastComment;
    #isFirstComment;
    #countrySeller;

    constructor(userId, productId, productOwnerId, isSeller, timeSinceLastComment, isFirstComment, countrySeller) {
        super(CommentCreatedEvent.eventType);
        
        this.#userId = userId;
        this.#productId = productId;
        this.#productOwnerId = productOwnerId;
        this.#isSeller = isSeller;
        this.#timeSinceLastComment = timeSinceLastComment;
        this.#isFirstComment = isFirstComment;
        this.#countrySeller = countrySeller;
    }

    get userId() {
        return this.#userId;
    } 

    get productId() {
        return this.#productId;
    } 

    get productOwnerId() {
        return this.#productOwnerId;
    } 

    get isSeller() {
        return this.#isSeller;
    } 

    get timeSinceLastComment() {
        return this.#timeSinceLastComment;
    } 

    get isFirstComment() {
        return this.#isFirstComment;
    }

    get countrySeller() {
        return this.#countrySeller;
    }

};
